module.exports = __webpack_public_path__ + "img/com_RNUTM.548098d1.png";